<template>
  <div>
    <v-container class="mt-10 ml-5 p-4" style="max-width:1000px">
      <v-row>
        <v-text-field style="max-width:400px" label="Search" v-model="query" />
        <v-btn class="mt-4" text><v-icon>mdi-magnify</v-icon></v-btn>
      </v-row>
    </v-container>
    <images :query="query" />
  </div>
</template>

<script>
import images from "./images";
export default {
  components: {
    images,
  },
  name: "maincomp",
  data: function() {
    return {
      query: "",
    };
  },
};
</script>

<style></style>
